import { ContratoDetalhesComponent } from './contrato-detalhes/contrato-detalhes.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContratosComponent } from './contratos.component';
import { ContratoFinanciamentoComponent } from './contrato-financiamento/contrato-financiamento.component';
import { ContratoBeneficiarioComponent } from './contrato-beneficiario/contrato-beneficiario.component';
import { ContractResolver } from 'src/app/services/resolvers/contract.resolver';
import { ContratoLogComponent } from './contrato-log/contrato-log.component';

const routes: Routes = [
  {
    path: ':contractNumber/:queryNumber/:financialInstitution',
    component: ContratosComponent,
    title: 'Detalhes do Contrato',
    resolve: { contracts: ContractResolver },
    children: [
      { path: '', redirectTo: 'detalhes', pathMatch: 'full' },
      {
        path: 'detalhes/:mode',
        component: ContratoDetalhesComponent,
        data: { title: 'Detalhes do Contrato' }
      },
      {
        path: 'financiamento/:mode',
        component: ContratoFinanciamentoComponent
      },
      { path: 'beneficiario/:mode', component: ContratoBeneficiarioComponent },
      { path: 'log/:mode', component: ContratoLogComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContratosRoutingModule {}
